import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const RebatesBreakdownPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    const appliedRebates = pdfData.applied_rebates.filter((r) => r.amount !== '0')
    if (!appliedRebates.length) return null

    return (
        <Panel title="Rebates Breakdown">
            {appliedRebates.map((r) => (
                <DataRow
                    key={`${r.name}-${r.amount}`}
                    label={r.name}
                    value={(r.amount * -1).toDollarFormat()}
                    variant="muted"
                />
            ))}
            <DataRow
                label="Total Rebates"
                value={pdfData.total_rebates.toDollarFormat()}
                isTotal
                variant="bold"
                isLast
            />
        </Panel>
    )
}
